<div class="points-shop">
  <h2><img src="../../../../assets/images/coin.png" alt="Coin"> Points Shop</h2>

  <div class="points-container">
    <div *ngFor="let pack of pointPacks"
         class="point-card"
         [class.popular]="pack.popular">

      <div *ngIf="pack.popular" class="most-popular">Most Popular</div>

      <h3>{{ pack.points }} Points</h3>
      <p class="price">{{ pack.price }}</p>
      <p *ngIf="pack.popular" class="best-value">Best Value!</p>

      <button class="purchase-btn btn" (click)="goToShop()">Purchase</button>
    </div>
  </div>
</div>
